<template>
  <div class="filter-group mb-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="text-white mb-0 d-flex align-items-center">
        <i :class="icon" class="text-success me-2"></i>
        {{ title }}
      </h6>
      <button 
        v-if="selectedCount"
        @click="clearSelection"
        class="btn btn-link btn-sm text-muted p-0"
        title="Limpiar selección"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="filter-options">
      <div
        v-for="option in sortedOptions"
        :key="option.id"
        class="form-check mb-2"
      >
        <input
          class="form-check-input"
          type="checkbox"
          :id="option.id"
          :value="option.id"
          :checked="modelValue.includes(option.id)"
          @change="updateValue(option.id)"
        />        <label class="form-check-label" 
          :class="{'text-white': modelValue.includes(option.id), 'text-white-50': !modelValue.includes(option.id)}" 
          :for="option.id">
          {{ option.name }}
          <span class="count" v-if="option.count">({{ option.count }})</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: true
  },
  options: {
    type: Array,
    required: true
  },
  modelValue: {
    type: Array,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

const selectedCount = computed(() => props.modelValue.length)

const updateValue = (id) => {
  console.log(`🔄 FilterGroup (${props.title}) updating:`, id);
  
  const newValue = [...props.modelValue]
  const index = newValue.indexOf(id)
  
  if (index === -1) {
    newValue.push(id)
  } else {
    newValue.splice(index, 1)
  }
  
  console.log(`🚀 Emitting:`, newValue);
  emit('update:modelValue', newValue)
}

const clearSelection = () => {
  console.log(`🧹 FilterGroup clearSelection called for: ${props.title}`);
  console.log(`🚀 Emitting empty array for update:modelValue`);
  emit('update:modelValue', [])
  // Asegurarse de que se actualice la URL después de limpiar la selección
  setTimeout(() => {
    // Esto permite que el componente padre aplique actualizaciones antes de continuar
  }, 10)
}

// Añade esta computed property para ordenar las opciones por nombre
const sortedOptions = computed(() => {
  return [...props.options].sort((a, b) => a.name.localeCompare(b.name))
})
</script>

<style scoped>
.filter-group {
  background: rgba(255, 255, 255, 0.03);
  padding: 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.filter-group:hover {
  background: rgba(255, 255, 255, 0.05);
}

.form-check-input {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  cursor: pointer;
}

.form-check-input:checked {
  background-color: var(--bs-success);
  border-color: var(--bs-success);
}

.form-check-label {
  cursor: pointer;
  font-weight: 300;
  transition: color 0.2s ease;
}

.form-check:hover .form-check-label {
  color: #fff !important;
}

.count {
  font-size: 0.85em;
  opacity: 0.7;
  margin-left: 0.25rem;
}

.badge {
  font-size: 0.7rem;
  padding: 0.25em 0.6em;
}

.btn-link {
  text-decoration: none;
  font-size: 0.8rem;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.btn-link:hover {
  opacity: 1;
}

.filter-options {
  max-height: 300px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.filter-options::-webkit-scrollbar {
  width: 6px;
}

.filter-options::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.filter-options::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.filter-options::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}
</style>